export const dischargeDateExists = (
  dischargeValues: Array<{ discharge_date?: unknown }> | null | undefined,
  index: number,
): boolean =>
  Boolean(
    dischargeValues && index < dischargeValues.length && dischargeValues[index]["discharge_date"],
  );
